import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Staff console mirror: inside /staff/console the employee's staff token
// authorizes the manager endpoints of their granted tabs (server-enforced).
api.interceptors.request.use((config) => {
  if (localStorage.getItem("staff_mirror") === "1") {
    const t = localStorage.getItem("staff_token");
    if (t) config.headers["X-Staff-Token"] = t;
  }
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "حدث خطأ غير متوقع";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const downloadFile = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

// فتح ملف محمي (شواهد ونحوها) في تبويب جديد مع رمز الصلاحيات — الروابط
// المباشرة لا ترفق X-Staff-Token فترفضها الخادمية لحسابات الصلاحيات
export const openProtectedFile = async (path) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export default api;
